export const GUIDE_STEP_KEY = 'transfer-guide-step'
export const GUIDE_STEP_INTRO = 'intro'
export const GUIDE_STEP_LEGAL = 'legal'

export const GUIDE_BY_OLD_FORM = 'byOldForm'
export const GUIDE_BY_OLD_FORM_QUERY_PARAM = 'by-old-form'
